// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.accordion__toggle::before,\n.accordion__toggle::after {\n  background-color: black !important;\n}\n", ""]);
// Exports
module.exports = exports;
